import { connect } from 'react-redux'
import OrdersEditView from './OrdersEditView.jsx'


class OrdersShipView extends OrdersEditView {
  constructor(props, context) {
    const localProps = {
      ...props,
      initialState: {
        status: 'completed'
      }
    }

    super(localProps, context)
  }
}

const mapStateToProps = (state) => {
  return {
    page: 'ship',
    order: state.orders.current.order,
    currentUser: state.currentUser.user,
    skus: state.skus.all || [],
    serverErrors: state.errors.orders.create || {}
  }
}

const connectedOrdersShipView = connect(mapStateToProps,)(OrdersShipView)
export default connectedOrdersShipView